const general = {
  name: {
    presence: {
      allowEmpty: false,
      message: "Nome é obrigatório."
    }
  },
  mandatory_quantity: function(_, attributes) {
    if (attributes.mandatory) {
      return {
        numericality: {
          greaterThan: 0,
          message:
            "Valor obrigatório ao marcar Quantidade mínima de opcionais por cliente"
        }
      };
    }
  },
  limited_value: function(_, attributes) {
    if (attributes.limited) {
      if (attributes.mandatory_quantity) {
        return {
          numericality: {
            greaterThanOrEqualTo:
              parseInt(attributes.mandatory_quantity, 10) || 0,
            message:
              "Valor deve ser maior ou igual ao informado em Quantidade mínima de opcionais por cliente"
          }
        };
      } else {
        return {
          numericality: {
            greaterThan: 0,
            message:
              "Valor obrigatório ao marcar Quantidade máxima de opcionais por cliente"
          }
        };
      }
    }
  },
  optionals: function(_, attributes) {
    const {
      mandatory,
      mandatory_quantity,
      limited,
      limited_value,
      optionals
    } = attributes;

    if (
      mandatory &&
      limited &&
      parseInt(mandatory_quantity, 10) > optionals.length &&
      parseInt(limited_value, 10) > optionals.length
    ) {
      return {
        length: {
          minimum:
            parseInt(mandatory_quantity, 10) || parseInt(limited_value, 10),
          message: `Informe no mínimo ${mandatory_quantity} opcionais.`
        }
      };
    } else if (
      mandatory &&
      limited &&
      (parseInt(mandatory_quantity, 10) > optionals.length ||
        parseInt(limited_value, 10) > optionals.length)
    ) {
      return {
        length: {
          minimum:
            parseInt(mandatory_quantity, 10) > optionals.length
              ? parseInt(mandatory_quantity, 10)
              : parseInt(limited_value, 10),
          message: `Informe no mínimo ${
            parseInt(mandatory_quantity, 10) > optionals.length
              ? parseInt(mandatory_quantity, 10)
              : parseInt(limited_value, 10)
          } opcionais.`
        }
      };
    } else if (mandatory) {
      return {
        length: {
          minimum: parseInt(mandatory_quantity, 10),
          message: `Informe no mínimo ${mandatory_quantity} opcionais.`
        }
      };
    } else if (limited) {
      return {
        length: {
          minimum:
            parseInt(mandatory_quantity, 10) || parseInt(limited_value, 10),
          message: `Informe no mínimo ${limited_value} opcionais.`
        }
      };
    } else {
      return {
        length: {
          minimum: 1,
          message: "Informe no mínimo 1 opcional."
        }
      };
    }
  }
};

export default {
  general
};



// WEBPACK FOOTER //
// ./src/core/constraint/optional-groups.constraint.js